import React, { useState, useEffect } from 'react';
import { fetchJobHistory } from '../api';
import '../workorderhistory.css' // We can reuse the same CSS

const JobHistory = ({ jobId, onClose }) => {
    const [changes, setChanges] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const loadHistoryAndDetectChanges = async () => {
            setLoading(true);
            try {
                const data = await fetchJobHistory(jobId);
                console.log('Received history data:', data); // Debug log
                const changes = detectChanges(data);
                console.log('Processed changes:', changes); // Debug log
                setChanges(changes);
                setError('');
            } catch (error) {
                console.error('Failed to fetch job history:', error);
                setError('Failed to load history');
            } finally {
                setLoading(false);
            }
        };

        loadHistoryAndDetectChanges();
    }, [jobId]);

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    // Function to detect changes between history records
    const detectChanges = (history) => {
        console.log('Starting detectChanges with history:', history); // Debug log
        return history.reduce((acc, current, index, array) => {
            if (index === 0) return acc;

            const previous = array[index - 1];
            const change = {};

            console.log('Processing record:', { current, previous }); // Debug log

            Object.keys(current).forEach(key => {
                if (current[key] !== previous[key] && 
                    key !== 'history_date' && 
                    key !== 'id' && 
                    key !== 'history_id' &&
                    key !== 'history_user' &&
                    key !== 'user_initials') { // Exclude user_initials from changes
                    change[key] = { 
                        from: current[key], 
                        to: previous[key]
                    };
                }
            });

            if (Object.keys(change).length) {
                const entry = { 
                    date: previous.history_date, 
                    changes: change,
                    user_initials: previous.user_initials // Keep showing initials in header
                };
                console.log('Created history entry:', entry); // Debug log
                acc.push(entry);
            }

            return acc;
        }, []);
    };

    return (
        <div className="workorderhistory">
            <div className="workorderhistory-header">
                <h2>Job History</h2>
                <button type='button' className='modal-close-btn' onClick={onClose}>Close</button>
            </div>
            {loading && <div className="loading">Loading history...</div>}
            {error && <div className="error">{error}</div>}
            <div className="history-content">
                {changes.length === 0 ? (
                    <div className="no-history">No history available</div>
                ) : (
                    <ul className="history-list">
                        {changes.map((entry, index) => (
                            <li key={index} className="history-entry">
                                <div className="history-header">
                                    <div className="history-date">
                                        {formatDateTime(entry.date)}
                                    </div>
                                    {entry.user_initials && (
                                        <div className="user-initials">
                                            {entry.user_initials}
                                        </div>
                                    )}
                                </div>
                                <div className="history-changes">
                                    {Object.entries(entry.changes).map(([field, { from, to }]) => (
                                        <div key={field} className="change-item">
                                            <span className="field-name">{field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:</span>
                                            <div className="change-values">
                                                <span className="old-value">"{from || 'empty'}"</span>
                                                <span className="change-arrow">→</span>
                                                <span className="new-value">"{to || 'empty'}"</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default JobHistory;